import { Grid, Tooltip } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Toolbar from '@material-ui/core/Toolbar';
import React from 'react';
import { useIntl } from 'react-intl';
import { componentMessages } from '../../component-translations';
import { HelpIcon, HomeIcon, LogoIcon, LogoutIcon, ProfileIcon, ShowMoreIcon } from './Icons';
const useStyles = makeStyles((theme) => ({
    logoGrid: {
        textAlign: 'center',
        marginTop: 'auto'
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            justifyContent: 'flex-end'
        }
    },
    sectionMobile: {
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    }
}));
export const IconList = (props) => {
    const { home, help, currentUser, logout, infoToolTipTitle, mobileMenuId, onMobileMenuOpen } = props;
    const { formatMessage } = useIntl();
    const classes = useStyles(props);
    return (React.createElement(Toolbar, null,
        React.createElement(Grid, { container: true, spacing: 1, alignItems: 'center' },
            React.createElement(Grid, { item: true, xs: 5 }, props.children),
            React.createElement(Grid, { item: true, xs: 2, className: classes.logoGrid },
                React.createElement(LogoIcon, { onClick: home })),
            React.createElement(Grid, { item: true, xs: 5, className: classes.sectionDesktop },
                !!home ? (React.createElement(HomeIcon, { onClick: home })) : null,
                !!help ? (infoToolTipTitle ?
                    React.createElement(Tooltip, { title: React.createElement("span", { style: { whiteSpace: 'pre-line' } }, `${formatMessage(componentMessages['help.toolTip.title'])}\n${infoToolTipTitle}`) },
                        React.createElement("span", null,
                            React.createElement(HelpIcon, { onClick: help })))
                    : React.createElement(HelpIcon, { onClick: help })) : null,
                !!currentUser ? (React.createElement(ProfileIcon, { onClick: currentUser })) : null,
                !!logout ? (React.createElement(LogoutIcon, { onClick: logout })) : null),
            React.createElement(Grid, { item: true, xs: 5, className: classes.sectionMobile },
                React.createElement(ShowMoreIcon, { mobileMenuId: mobileMenuId, onMobileMenuOpen: onMobileMenuOpen })))));
};
//# sourceMappingURL=IconList.js.map